import { render, staticRenderFns } from "./zibenhua.vue?vue&type=template&id=025033dc&scoped=true&"
import script from "./zibenhua.vue?vue&type=script&lang=js&"
export * from "./zibenhua.vue?vue&type=script&lang=js&"
import style0 from "./zibenhua.vue?vue&type=style&index=0&id=025033dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025033dc",
  null
  
)

export default component.exports